<template>
    <v-container fluid>
        <v-layout>
            <v-flex>
                <v-alert :color="color" outline :value="true">
                    <v-layout align-center>
                        <v-flex xs2><i class="material-icons mr-2"> {{ icon }} </i></v-flex>
                        <v-flex>
                            {{ !!index? `${index} - `: '' }} {{ item.name }}
                        </v-flex>
                    </v-layout>
                </v-alert>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex v-for="(answer, index) in checklistAnswers" :key="answer.id" :class="{'ml-2': index > 0, 'mr-2': index < checklistAnswers.length - 1}">
                <v-btn
                    class="white--text px-2"
                    @click="() => answerQuestion(item.id, answer)"
                    block
                    :color="answer.color"
                >{{ answer.name }}</v-btn>
            </v-flex>
        </v-layout>
        
    </v-container>
</template>
<script>

export default {
    props: {
        item: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: 0
        }
    },
    data: () => ({
        color: 'info',
        icon: 'info'
    }),
    methods: {
        answerQuestion(checklistItemId, answer) {
            this.color = answer.color;
            this.icon = answer.icon;
            this.$emit('answer', {checklistItemId, answerId: answer.id, answerDate: this.$dt.now()});
        },
        autoLoadResponse() {
            const item = this.roundInProgress.checklistItems.find(item => item.checklistItemId === this.item.id);
            
            if(!item) return;

            const answer = this.checklistAnswers.find(answer => answer.id === item.answerId);

            this.color = answer.color;
            this.icon = answer.icon;
        }
    },
    mounted() {
        this.autoLoadResponse();
    }
}
</script>
